import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from '@/common/ui/select'
import useMutationUpdateGeneralSetting from '@/modules/client-setting/api/hooks/useMutationUpdateGeneralSetting'
import { GetGeneralSettingResponse } from '@/modules/client-setting/type'
import { useState } from 'react'
import { toast } from 'sonner'
import showErrorToast from '@/common/utils/showErrorToast'
import { useQueryClient } from '@tanstack/react-query'
import { GeneralSettingQueryKeys } from '@/modules/client-setting/keys'
import useHasPermission from '@/common/hooks/useHasPermission'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import { InitType } from '@/schema'

interface InitTypeProps {
	data: GetGeneralSettingResponse
}

export function InitTypeComponent({ data }: InitTypeProps) {
	const queryClient = useQueryClient()
	const [isLoading, setIsLoading] = useState(false)
	const { mutateAsync: updateGeneralSetting } =
		useMutationUpdateGeneralSetting()
	const hasWritePermission = useHasPermission(PermissionKeys.WEB_SETTING)

	const handleChange = async (value: string) => {
		if (!hasWritePermission) return

		setIsLoading(true)
		try {
			await updateGeneralSetting({
				payload: {
					...data,
					initType: value as InitType,
				},
			})
			toast.success('อัพเดทการตั้งค่าโหมดเปิดเกมสำเร็จ')
			queryClient.invalidateQueries({
				queryKey: [GeneralSettingQueryKeys.GetGeneralSetting],
			})
		} catch (error) {
			showErrorToast(error as Error)
		} finally {
			setIsLoading(false)
		}
	}

	return (
		<Select
			value={data?.initType ?? InitType.IFRAME}
			onValueChange={handleChange}
			disabled={isLoading || !hasWritePermission}
		>
			<SelectTrigger className="w-[180px]">
				<SelectValue placeholder="เลือกโหมด" />
			</SelectTrigger>
			<SelectContent>
				<SelectItem value={InitType.IFRAME}>IFRAME</SelectItem>
				<SelectItem value={InitType.EXTERNAL}>EXTERNAL</SelectItem>
			</SelectContent>
		</Select>
	)
}
